import { render, staticRenderFns } from "./ListaCompeticiones.vue?vue&type=template&id=b98c1158&scoped=true"
import script from "./ListaCompeticiones.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListaCompeticiones.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ListaCompeticiones.vue?vue&type=style&index=0&id=b98c1158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98c1158",
  null
  
)

export default component.exports